import { Link } from 'react-router-dom';

export default function CTASection() {
  return (
    <section className="relative w-full min-h-[600px] overflow-hidden flex items-center justify-center">
      <img
        src="https://public.readdy.ai/ai/img_res/d9329c1dd4f32422434cc70941236fda.jpg"
        alt="Panoramic mountain views from luxury cabin deck in Highlands NC"
        className="absolute inset-0 w-full h-full object-cover object-center"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-black/30 via-black/40 to-black/50" />

      <div className="relative z-10 text-center px-6 max-w-3xl mx-auto">
        <p className="text-[#C9A96E] text-xs tracking-[0.35em] uppercase font-jost mb-6">/ Your Mountain Escape Awaits</p>
        <h2 className="font-cormorant text-6xl md:text-7xl text-white font-light leading-none mb-6">
          Find Your Perfect<br />
          <em className="italic">Highlands Retreat</em>
        </h2>
        <p className="text-white/70 font-jost text-base leading-relaxed mb-10 max-w-lg mx-auto">
          Whether you're seeking a romantic hideaway beside a waterfall, a family estate with mountain views, or a pet-friendly sanctuary in the forest — we'll help you find it.
        </p>
        <Link
          to="/best-luxury-cabins"
          className="inline-flex items-center gap-3 bg-[#C9A96E] hover:bg-[#B8954F] text-white text-xs tracking-[0.2em] uppercase font-jost font-medium px-12 py-5 rounded-full transition-colors cursor-pointer whitespace-nowrap"
        >
          Browse All Cabins
          <div className="w-4 h-4 flex items-center justify-center">
            <i className="ri-arrow-right-line" />
          </div>
        </Link>
      </div>
    </section>
  );
}